import { render, staticRenderFns } from "./EditarLicitacao.vue?vue&type=template&id=7b10d28b"
import script from "./EditarLicitacao.vue?vue&type=script&lang=ts"
export * from "./EditarLicitacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports